import {
  adminCandidateList,
  adminCandidateReportSummary,
  adminCandidateReportDetails,
  CandidateFinalConclusion,
  adminLogin,
  adminLogout, fetchCheckDetails, manualCourtCheck, JobSeeekerIdChange,
  FetchCheckFields,
  ManualWork,
  CandidateUpdateChecks,
  manualOFACCheck,
  manualForm26ASCheck,
  manualForm16Check,
  manualBankVerificationCheck,
  manualSalaryVerificationCheck,
  PendingChecksReport,
  UpdateResumeUrl,
  ManualDocumentsGenerateUrl,
  GenerateDailyClientReport,
  GenerateDailyVendorReport,
  GenerateCandidateStatusCancelReport,
  ManualDocumentsFetchUrl,
  CandidateTechFinalConclusion,
  AdminInvoiceGeneration,
  UpdateCandidateAddress,
  UpdateCandidatePersonalInfo,
  ClosedInsufficiencyComments
} from "../actions/AdminActions";
import { createSlice } from "@reduxjs/toolkit";
import { manualBankCheck } from "../actions/AdminRunChecksAction";

const adminCandidateListSlice = createSlice({
  name: "adminCandidateList",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminCandidateList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminCandidateList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(adminCandidateList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const adminCandidateReportSlice = createSlice({
  name: "adminCandidateReport",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminCandidateReportSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminCandidateReportSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(adminCandidateReportSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const adminCandidateReportDetailsSlice = createSlice({
  name: "adminCandidateReportDetails",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminCandidateReportDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminCandidateReportDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(adminCandidateReportDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const CandidateFinalConclusionSlice = createSlice({
  name: "CandidateFinalConclusion",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CandidateFinalConclusion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(CandidateFinalConclusion.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(CandidateFinalConclusion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const adminLoginSlice = createSlice({
  name: "adminLogin",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(adminLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const adminLogoutSlice = createSlice({
  name: "adminLogout",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminLogout.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminLogout.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(adminLogout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const fetchChecksSlice = createSlice({
  name: "fetchCheckDetails",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCheckDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCheckDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(fetchCheckDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualCourtCheckSlice = createSlice({
  name: "manualCourtCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualCourtCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualCourtCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualCourtCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const JobSeeekerIdChangeSlice = createSlice({
  name: "JobSeeekerIdChange",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(JobSeeekerIdChange.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(JobSeeekerIdChange.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(JobSeeekerIdChange.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const PendingChecksReportSlice = createSlice({
  name: "PendingChecksReport",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(PendingChecksReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(PendingChecksReport.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(PendingChecksReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const FetchCheckFieldsSlice = createSlice({
  name: "FetchCheckFields",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(FetchCheckFields.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchCheckFields.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(FetchCheckFields.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const ManualWorkSlice = createSlice({
  name: "ManualWork",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ManualWork.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(ManualWork.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(ManualWork.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const CandidateUpdateChecksSlice = createSlice({
  name: "ManualWork",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CandidateUpdateChecks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(CandidateUpdateChecks.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(CandidateUpdateChecks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualOFACCheckSlice = createSlice({
  name: "manualOFACCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualOFACCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualOFACCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualOFACCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualForm16CheckSlice = createSlice({
  name: "manualForm16Check",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualForm16Check.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualForm16Check.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
        }
      })
      .addCase(manualForm16Check.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
        }
      });
  },
});

const manualForm26ASCheckSlice = createSlice({
  name: "manualForm26ASCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualForm26ASCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualForm26ASCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualForm26ASCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualBankVerificationCheckSlice = createSlice({
  name: "manualBankVerificationCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualBankVerificationCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualBankVerificationCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualBankVerificationCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualSalaryVerificationCheckSlice = createSlice({
  name: "manualSalaryVerificationCheck",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualSalaryVerificationCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualSalaryVerificationCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualSalaryVerificationCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const UpdateResumeUrlSlice = createSlice({
  name: "UpdateResumeUrl",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(UpdateResumeUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(UpdateResumeUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(UpdateResumeUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const ManualDocumentsGenerateUrlSlice = createSlice({
  name: "ManualDocumentsGenerateUrl",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ManualDocumentsGenerateUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(ManualDocumentsGenerateUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(ManualDocumentsGenerateUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const GenerateDailyClientReportSlice = createSlice({
  name: "GenerateDailyClientReport",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GenerateDailyClientReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GenerateDailyClientReport.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(GenerateDailyClientReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const GenerateDailyVendorReportSlice = createSlice({
  name: "GenerateDailyVendorReport",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GenerateDailyVendorReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GenerateDailyVendorReport.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(GenerateDailyVendorReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const GenerateCandidateStatusCancelReportSlice = createSlice({
  name: "GenerateCandidateStatusCancelReport",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GenerateCandidateStatusCancelReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GenerateCandidateStatusCancelReport.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(GenerateCandidateStatusCancelReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const ManualDocumentsFetchUrlSlice = createSlice({
  name: "ManualDocumentsFetchUrl",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ManualDocumentsFetchUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(ManualDocumentsFetchUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(ManualDocumentsFetchUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const CandidateTechFinalConclusionSlice = createSlice({
  name: "CandidateTechFinalConclusion",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CandidateTechFinalConclusion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(CandidateTechFinalConclusion.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(CandidateTechFinalConclusion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const AdminInvoiceGenerationSlice = createSlice({
  name: "AdminInvoiceGeneration",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AdminInvoiceGeneration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AdminInvoiceGeneration.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(AdminInvoiceGeneration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const UpdateCandidateAddressSlice = createSlice({
  name: "UpdateCandidateAddress",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(UpdateCandidateAddress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(UpdateCandidateAddress.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(UpdateCandidateAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const UpdateCandidatePersonalInfoSlice = createSlice({
  name: "UpdateCandidatePersonalInfo",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(UpdateCandidatePersonalInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(UpdateCandidatePersonalInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(UpdateCandidatePersonalInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const ClosedInsufficiencyCommentsSlice = createSlice({
  name: "ClosedInsufficiencyComments",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ClosedInsufficiencyComments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(ClosedInsufficiencyComments.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(ClosedInsufficiencyComments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});


export const reducers = {
  adminCandidateList: adminCandidateListSlice.reducer,
  adminCandidateReport: adminCandidateReportSlice.reducer,
  adminCandidateReportDetails: adminCandidateReportDetailsSlice.reducer,
  CandidateFinalConclusion: CandidateFinalConclusionSlice.reducer,
  adminLogin: adminLoginSlice.reducer,
  adminLogout: adminLogoutSlice.reducer,
  fetchCheckDetails: fetchChecksSlice.reducer,
  manualCourtCheck: manualCourtCheckSlice.reducer,
  JobSeeekerIdChange: JobSeeekerIdChangeSlice.reducer,
  ManualWork:ManualWorkSlice.reducer,
  FetchCheckFields: FetchCheckFieldsSlice.reducer,
  CandidateUpdateChecks:CandidateUpdateChecksSlice.reducer,
  manualOFACCheck: manualOFACCheckSlice.reducer,
  manualForm26ASCheck: manualForm26ASCheckSlice.reducer,
  manualForm16Check: manualForm16CheckSlice.reducer,
  manualBankVerificationCheck: manualBankVerificationCheckSlice.reducer,
  manualSalaryVerificationCheck: manualSalaryVerificationCheckSlice.reducer,
  PendingChecksReport: PendingChecksReportSlice.reducer,
  UpdateResumeUrl: UpdateResumeUrlSlice.reducer,
  ManualDocumentsGenerateUrl: ManualDocumentsGenerateUrlSlice.reducer,
  GenerateDailyVendorReport: GenerateDailyVendorReportSlice.reducer,
  GenerateDailyClientReport: GenerateDailyClientReportSlice.reducer,
  GenerateCandidateStatusCancelReport: GenerateCandidateStatusCancelReportSlice.reducer,
  ManualDocumentsFetchUrl: ManualDocumentsFetchUrlSlice.reducer, 
  CandidateTechFinalConclusion: CandidateTechFinalConclusionSlice.reducer,
  AdminInvoiceGeneration:AdminInvoiceGenerationSlice.reducer,
  UpdateCandidateAddress:UpdateCandidateAddressSlice.reducer,
  UpdateCandidatePersonalInfo:UpdateCandidatePersonalInfoSlice.reducer,
  ClosedInsufficiencyComments:ClosedInsufficiencyCommentsSlice.reducer
};
